import React, { memo, forwardRef } from "react";
const SvgOmega = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12.584 22.656c-.992 0-1.832-.272-2.52-.816-.672-.544-1.184-1.304-1.536-2.28C8.176 18.584 8 17.456 8 16.176c0-1.52.208-2.832.624-3.936.36-.954.785-1.753 1.276-2.397a.763.763 0 01.611-.291c.7 0 1.117.858.78 1.471l-.099.185c-.32.624-.584 1.352-.792 2.184-.192.832-.288 1.768-.288 2.808 0 1.552.24 2.728.72 3.528.48.784 1.112 1.176 1.896 1.176.528 0 .96-.136 1.296-.408.352-.272.608-.64.768-1.104.16-.48.24-1.016.24-1.608V14.92c0-.552.456-1 1.008-1s1.008.448 1.008 1v2.864c0 .656.088 1.224.264 1.704.192.464.456.816.792 1.056.336.24.744.36 1.224.36.544 0 1.008-.176 1.392-.528.4-.352.704-.88.912-1.584.224-.704.336-1.568.336-2.592 0-1.008-.088-1.912-.264-2.712a8.563 8.563 0 00-.768-2.184 8.653 8.653 0 00-.142-.279c-.328-.616.082-1.473.78-1.473.235 0 .46.1.605.285.335.428.633.91.893 1.443.32.64.568 1.368.744 2.184.176.816.264 1.72.264 2.712 0 1.28-.176 2.408-.528 3.384-.352.976-.872 1.736-1.56 2.28-.672.544-1.504.816-2.496.816-.88 0-1.6-.2-2.16-.6-.56-.416-.976-1.096-1.248-2.04h-.12c-.16.624-.392 1.136-.696 1.536-.304.384-.68.664-1.128.84-.448.176-.968.264-1.56.264z"
      />
    </svg>
  );
});
SvgOmega.displayName = "SvgOmega";
const MemoForwardRef = memo(SvgOmega);
export default MemoForwardRef;
